import { Typography } from "@mui/material";
import React from "react";
import "../analytics/analytics.css";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const UploadErrorScenarios = ({ uploadFileErrors }) => {
  return (
    <>
      {uploadFileErrors?.response?.status === 415 ? (
        <>
          <img src="/assets/fileIcons/invalid_format.svg" />
          <Typography
            className="bodyB1SemiBold"
            sx={{
              color: "rgba(79, 77, 85, 1)",
              marginTop: "8px",
            }}
          >
            Invalid file format
          </Typography>
          <Typography
            className="bodyB2RegularText"
            style={{ color: "var(--Text-Medium)" }}
          >
            {uploadFileErrors?.response?.data?.message}
          </Typography>
        </>
      ) : (
        <>
          <img src="/assets/fileIcons/invalid_header_file.svg" />
          <Typography
            className="bodyB1SemiBold"
            sx={{
              color: "rgba(79, 77, 85, 1)",
              marginTop: "8px",
            }}
          >
            {uploadFileErrors?.response?.data?.message}
          </Typography>
          {uploadFileErrors?.response?.data?.fieldErrorItems && (
            <div className="field-error-container">
              {uploadFileErrors?.response?.data?.fieldErrorItems.map(
                (error) => (
                  <div className="field-error-item">
                    <ErrorOutlineIcon
                      style={{
                        height: "24px",
                        width: "24px",
                        color: "#B9232F",
                      }}
                    />
                    <Typography
                      className="bodyB2RegularText"
                      style={{ color: "var(--Text-Medium)" }}
                    >
                      {error?.message}
                    </Typography>
                  </div>
                )
              )}
            </div>
          )}
          <Typography
            className="bodyB2RegularText"
            style={{ color: "var(--Text-Medium)" }}
          >
            Note: Please review and ensure all necessary information is
            included.
          </Typography>
        </>
      )}
    </>
  );
};

export default UploadErrorScenarios;
